import { render, staticRenderFns } from "./BasicList.vue?vue&type=template&id=0003de97&"
import script from "./BasicList.vue?vue&type=script&lang=js&"
export * from "./BasicList.vue?vue&type=script&lang=js&"
import style0 from "./BasicList.vue?vue&type=style&index=0&id=0003de97&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports